import "./styles.css";
import Main from "./Components/Main";
import { ToastContainer } from "react-toastify";

function App() {
  return <Main />;
}

export default App;
